/**
 * The human-readable build version shown in the My Account menu and the admin
 * sidebar: `<short commit> · <build date>` (e.g. `b537be4 · Oct 6`), or `dev`
 * locally. Values are inlined at build time by script/build.ts via Vite defines;
 * `/version.json` serves the same fields, which is how `db:refresh-staging`
 * checks that prod and staging run the same build before mirroring data.
 */
const commit = (import.meta.env.VITE_BUILD_COMMIT as string | undefined) ?? "dev";
const builtAt = (import.meta.env.VITE_BUILT_AT as string | undefined) ?? "";

export const BUILD_COMMIT = commit;
export const BUILD_VERSION =
  commit === "dev"
    ? "dev build"
    : `${commit.slice(0, 7)}${
        builtAt
          ? ` · ${new Date(builtAt).toLocaleDateString(undefined, { month: "short", day: "numeric" })}`
          : ""
      }`;
